import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Component used render an item in a form.
 *
 * **Base CSS Class:** `ph-form-item`
 */

export default function CoreFormItem({ className, children, fill }) {
	return (
		<div className={classnames('ph-form-item', className, { fill })}>
			{Children.toArray(children)}
		</div>
	);
}

CoreFormItem.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	fill: PropTypes.bool
};
